


























import {
    getIsDismissed,
    setIsDismissed,
} from '@sportOfferFederation/bet-builder/store/storage';
import { SdsButtonIcon } from '@superbet-group/web.lib.ui-components';
import {
    defineComponent,
    ref,
} from '@vue/composition-api';

export default defineComponent({
    name: 'BetBuilderBanner',
    props: {
        name: {
            type: String,
            required: true,
        },
        isDismissable: {
            type: Boolean,
            required: false,
            default: false,
        },
        tag: {
            type: String,
            required: false,
            default: 'div',
        },
    },
    emits: ['onDismiss'],
    setup(props, { emit }) {
        const isDismissed = ref(getIsDismissed(props.name));

        function handleDismissal(e: MouseEvent) {
            emit('onDismiss', e);
            isDismissed.value = true;
            setIsDismissed(props.name);
        }

        return { isDismissed, handleDismissal };
    },
    components: {
        SdsButtonIcon,
    },
});
